import { render, staticRenderFns } from "./ValidationNotAllowedWord.vue?vue&type=template&id=249b777e&"
import script from "./ValidationNotAllowedWord.vue?vue&type=script&lang=js&"
export * from "./ValidationNotAllowedWord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports